var _style, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.4 188.8",
    style: {
      enableBackground: "new 0 0 290.4 188.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;}\n\t.st1{fill:url(#Union_8-2_00000092442416650806857740000017220515870459867575_);}\n\t.st2{fill:url(#Union_6-2_00000003816961931993148660000008325401420954732215_);}\n\t.st3{fill:url(#Rectangle_474-2_00000000212310030945735230000004645233921641436820_);}\n\t.st4{fill:url(#Rectangle_484-2_00000104682023320676602460000011515749019277299858_);}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:none;stroke:#C9C9C9;stroke-width:1.5;}\n\t.st7{opacity:0.25;fill:url(#Ellipse_51-2_00000045607554229201567410000000159509227969627013_);enable-background:new    ;}\n\t.st8{opacity:0.5;fill:url(#Ellipse_50-2_00000164509327411513571330000006454152561085574804_);enable-background:new    ;}\n\t.st9{opacity:0.75;fill:url(#Ellipse_49-2_00000137115933664384980300000009618965091986312637_);enable-background:new    ;}\n\t.st10{fill:url(#Path_16690-2_00000177453839588200757500000003972406171740704178_);}\n\t.st11{fill:url(#Path_16691_00000057131110598362094040000006606955782933116073_);}\n\t.st12{opacity:0.75;}\n\t.st13{fill:url(#Exclusion_3-2_00000068667595492755603250000006298926989265162639_);}\n\t.st14{fill:url(#Union_11-2_00000177452354676652377070000002908363949279255716_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4852",
    transform: "translate(-21.195 -99.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4848",
    transform: "translate(64.695 172.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    transform: "translate(0 23.665)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, -96.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_8-2_00000023272638667952746020000015115303986260176774_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.1177,
    y1: 511.728,
    x2: -148.1177,
    y2: 510.728,
    gradientTransform: "matrix(120.141 0 0 -40.768 17855.0801 20992.5098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_8-2",
    style: {
      fill: "url(#Union_8-2_00000023272638667952746020000015115303986260176774_)"
    },
    d: "M92.2,171.1H6.3 c-3.5,0-6.3-2.8-6.3-6.3c0,0,0,0,0,0v-1.1c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0h40.2c3.8-0.1,6.7-3.2,6.6-7 c-0.1-3.7-3.1-6.6-6.8-6.6h-2.8l0,0h-8.8c-3.5,0-6.3-2.8-6.3-6.3v-1.1c0-3.5,2.8-6.3,6.3-6.3h79.1c3.5,0,6.3,2.8,6.3,6.3v1.1 c0,3.5-2.8,6.3-6.3,6.3H92.2l0,0h-2.8c-3.8,0-6.8,3-6.8,6.8c0,3.7,3,6.7,6.7,6.8h19.3c3.5,0,6.3,2.8,6.3,6.3c0,0,0,0,0,0v1.1 c0,3.5-2.8,6.3-6.3,6.3L92.2,171.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, -96.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_6-2_00000075145978135464343340000010666419856216795520_",
    gradientUnits: "userSpaceOnUse",
    x1: -147.9534,
    y1: 513.0934,
    x2: -147.9534,
    y2: 512.0934,
    gradientTransform: "matrix(101.281 0 0 -52.385 15223.4287 26908.1953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_6-2",
    style: {
      fill: "url(#Union_6-2_00000075145978135464343340000010666419856216795520_)"
    },
    d: "M201.6,82.2 c-3.5,0-6.3-2.8-6.3-6.3c0,0,0,0,0,0v-6.4c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0h3.3v0h1.3c2.1,0,4.1-0.8,5.6-2.2 c1.5-1.4,2.3-3.2,2.3-5.2c-0.1-3.5-2.6-6.5-6-7.2h-11.1c-5,0-9-4-9-9v-0.9c0-5,4-9,9-9h56c5,0,9,4,9,9v0.9c0,5-4,9-9,9h-15.6 c-1.4,0.3-2.7,1-3.7,2c-1.5,1.3-2.3,3.2-2.3,5.2c0.1,4.2,3.6,7.5,7.8,7.4v0h43.8c3.5,0,6.3,2.8,6.3,6.3v6.4 c0,3.5-2.8,6.3-6.3,6.3H201.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, -96.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_474-2_00000008868920732273163400000017788618927367097018_",
    gradientUnits: "userSpaceOnUse",
    x1: -144.1314,
    y1: 503.3172,
    x2: -144.1314,
    y2: 502.3172,
    gradientTransform: "matrix(21.772 0 0 -17.23 3417.5139 8702.9756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_474-2",
    style: {
      fill: "url(#Rectangle_474-2_00000008868920732273163400000017788618927367097018_)"
    },
    d: " M276.6,30.8h5.8c4.4,0,8,3.6,8,8V40c0,4.4-3.6,8-8,8h-5.8c-4.4,0-8-3.6-8-8v-1.2C268.6,34.4,272.2,30.8,276.6,30.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, -96.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_484-2_00000178180241120721479020000018414199278071008128_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.8315,
    y1: 498.9128,
    x2: -142.8315,
    y2: 497.9128,
    gradientTransform: "matrix(17.184 0 0 -13.23 2464.5779 6730.9961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_484-2",
    style: {
      fill: "url(#Rectangle_484-2_00000178180241120721479020000018414199278071008128_)"
    },
    d: " M8.2,130.4h4c3.7,0,6.6,3,6.6,6.6l0,0c0,3.7-3,6.6-6.6,6.6h-4c-3.7,0-6.6-3-6.6-6.6l0,0C1.6,133.3,4.5,130.4,8.2,130.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, -96.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_433-2",
    transform: "translate(139.97 96.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.3353,
    y1: 400.7784,
    x2: -280.3353,
    y2: 399.7784,
    gradientTransform: "matrix(12.276 0 0 -12.276 3404.0337 4846.9561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: -37.4,
    cy: -66.9,
    rx: 6.1,
    ry: 6.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: -37.4,
    cy: -66.9,
    rx: 5.4,
    ry: 5.4
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    transform: "translate(49.658 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -93.16, -73)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_51-2_00000170272877384800649170000015614934114323777718_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.4398,
    y1: 516.5604,
    x2: -148.4398,
    y2: 515.5604,
    gradientTransform: "matrix(189.888 0 0 -188.81 28331.5352 97531.7734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51-2",
    style: {
      opacity: 0.25,
      fill: "url(#Ellipse_51-2_00000170272877384800649170000015614934114323777718_)",
      enableBackground: "new"
    },
    cx: 144.6,
    cy: 94.4,
    rx: 94.9,
    ry: 94.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -93.16, -73)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_50-2_00000060722635424428452150000012805733042165195670_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.4075,
    y1: 516.4998,
    x2: -148.4075,
    y2: 515.4998,
    gradientTransform: "matrix(179.496 0 0 -180.576 26783.1426 93271.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50-2",
    style: {
      opacity: 0.5,
      fill: "url(#Ellipse_50-2_00000060722635424428452150000012805733042165195670_)",
      enableBackground: "new"
    },
    cx: 144.6,
    cy: 94.4,
    rx: 89.7,
    ry: 90.3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -93.16, -73)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_49-2_00000163035872615493880580000009448035958018907533_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.3135,
    y1: 516.2689,
    x2: -148.3135,
    y2: 515.2689,
    gradientTransform: "matrix(154.85 0 0 -154.85 23110.9453 79960.5547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49-2",
    style: {
      opacity: 0.75,
      fill: "url(#Ellipse_49-2_00000163035872615493880580000009448035958018907533_)",
      enableBackground: "new"
    },
    cx: 144.6,
    cy: 93.7,
    r: 77.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -93.16, -73)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_16690-2_00000085938347565538305430000014689246479268624276_",
    gradientUnits: "userSpaceOnUse",
    x1: -147.5685,
    y1: 514.5049,
    x2: -147.5685,
    y2: 513.5049,
    gradientTransform: "matrix(74.152 0 0 -74.152 11087.1064 38208.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16690-2",
    style: {
      fill: "url(#Path_16690-2_00000085938347565538305430000014689246479268624276_)"
    },
    d: "M144.6,57 c20.5,0,37.1,16.6,37.1,37.1s-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1S124.1,57,144.6,57C144.6,57,144.6,57,144.6,57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_16691_00000116204318618658642620000017990802199661658790_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.5585,
    y1: 436.7101,
    x2: -239.5585,
    y2: 435.7101,
    gradientTransform: "matrix(40.7767 0 0 -30.6857 9819.8359 13406.6924)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60EAC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0FB683"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16691",
    style: {
      fill: "url(#Path_16691_00000116204318618658642620000017990802199661658790_)"
    },
    d: "M45.3,26.7 c2.9-2.9,5.7-5.7,8.5-8.6c3.6-3.6,7.3-7.3,10.9-10.9c1.5-1.7,4.1-1.8,5.7-0.3c1.2,1.1,1.7,2.9,1.1,4.4c-0.3,0.7-0.7,1.3-1.2,1.8 C63.1,20.5,55.8,27.7,48.6,35c-2.2,2.2-4.4,2.1-6.6,0c-3.1-3.1-6.3-6.3-9.4-9.4c-1.7-1.4-2-4-0.5-5.8c1.4-1.7,4-2,5.8-0.5 c0.2,0.2,0.4,0.3,0.5,0.5c2,2,4,4.1,6.1,6.1C44.6,26.1,45,26.4,45.3,26.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    transform: "translate(95.489 187.25)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -74.29, -87.88)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Exclusion_3-2_00000042000676472759659730000010136293183388363161_",
    gradientUnits: "userSpaceOnUse",
    x1: -140.5993,
    y1: 497.9851,
    x2: -140.5993,
    y2: 496.9851,
    gradientTransform: "matrix(12.612 0 0 -12.612 2008.8145 6441.8989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3-2",
    style: {
      fill: "url(#Exclusion_3-2_00000042000676472759659730000010136293183388363161_)"
    },
    d: " M235.6,173.9c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3l0,0C241.9,171.1,239.1,173.9,235.6,173.9z  M235.6,164.1c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5l0,0C239.1,165.7,237.5,164.1,235.6,164.1L235.6,164.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -74.29, -87.88)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Union_11-2_00000030474824560313204530000011572238267071112586_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.9403,
    y1: 496.6575,
    x2: -150.9403,
    y2: 495.6575,
    gradientTransform: "matrix(11.2738 -6.0212 -6.0214 -11.2741 4728.6587 4708.3965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23E6B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1FBF8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCFCFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_11-2",
    style: {
      fill: "url(#Union_11-2_00000030474824560313204530000011572238267071112586_)"
    },
    d: "M40.7,28.6 l-1.8-3.4l-3.4,1.8c-0.6,0.3-1.4,0.1-1.7-0.5c-0.3-0.6-0.1-1.4,0.5-1.7c0,0,0,0,0,0l3.4-1.8l-1.8-3.4c-0.3-0.6-0.1-1.4,0.5-1.7 c0.6-0.3,1.4-0.1,1.7,0.5l1.8,3.4l3.4-1.8c0.6-0.3,1.4-0.1,1.7,0.5c0.3,0.6,0.1,1.4-0.5,1.7c0,0,0,0,0,0l-3.4,1.8l1.8,3.4 c0.3,0.6,0.1,1.4-0.5,1.7C41.8,29.5,41.1,29.3,40.7,28.6C40.7,28.6,40.7,28.6,40.7,28.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateSuccess);
export default __webpack_public_path__ + "static/media/state-success.2f608f2de2c9c4d28f9f1deca3519aa1.svg";
export { ForwardRef as ReactComponent };